/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper';
import * as Permission from '../util/Permission';

import countries from '../intl/messages/countries.en';
import {DEFAULT_CURRENCY, DEFAULT_LOCALE, DEFAULT_TIMEZONE} from '../../common/locales';

export const RequiredPayPlans = {
    "-": {
        name: "All plans (Personal Plan)",
        priority: 10,
    },
    "plan-2": {
        name: "Standard Plan",
        priority: 20,
    },
    "plan-3": {
        name: "Premium Plan",
        priority: 30,
    },
    "plan-4": {
        name: "Enterprise Plan",
        priority: 40,
    },
    "developer": {
        name: "Developers Only",
        priority: 50,
    },
};

export const BILLING_STATUS_BILLED       = "billed";
export const BILLING_STATUS_TRIAL        = "trial";
export const BILLING_STATUS_DEVELOPER    = "developer";
export const BILLING_STATUS_FREE         = "free";

export const BillingStatus = {
    "": {
        name: "Unknown",
        priority: 10,
    },
    [BILLING_STATUS_TRIAL]: {
        name: "Trial",
        priority: 20,
    },
    [BILLING_STATUS_DEVELOPER]: {
        name: "Developer",
        priority: 30,
    },
    [BILLING_STATUS_FREE]: {
        name: "For free",
        priority: 40,
    },
    [BILLING_STATUS_BILLED]: {
        name: "Billed",
        priority: 60,
    },
};

export const VERSION_STRATEGY_VERY_CONSERVATIVE = "very-conservative";
export const VERSION_STRATEGY_CONSERVATIVE      = "conservative";
export const VERSION_STRATEGY_NORMAL            = "normal";
export const VERSION_STRATEGY_EARLY_ADAPTOR     = "early_adopter";
export const VERSION_STRATEGY_DEVELOPMENT       = "development";
export const VERSION_STRATEGY_KEEP_VERSION      = "keep-version";
export const VERSION_STRATEGY_FROM_ORGANISATION = "from-organisation";

export const VersionStrategyForOrganisation = {
    [VERSION_STRATEGY_VERY_CONSERVATIVE]: {
        name: "Very conservative",
        priority: 20,
    },
    [VERSION_STRATEGY_CONSERVATIVE]: {
        name: "Conservative",
        priority: 30,
    },
    [VERSION_STRATEGY_NORMAL]: {
        name: "Normal",
        priority: 40,
    },

    [VERSION_STRATEGY_EARLY_ADAPTOR]: {
        name: "Early adopter",
        priority: 50,
    },
    [VERSION_STRATEGY_DEVELOPMENT]: {
        name: "Development",
        priority: 60,
        isDevelopment: true,
        isSpecial: true,
    },
};

export const VersionStrategy = {
    [VERSION_STRATEGY_FROM_ORGANISATION]: {
        name: "< same as organisation >",
        priority: 10,
        isSpecial: true,
    },
    ...VersionStrategyForOrganisation,
    [VERSION_STRATEGY_KEEP_VERSION]: {
        name: "Keep version",
        priority: 70,
        isSpecial: true,
    },
};




export const BillingCurrency = {
    "CZK": {
        name: "CZK",
    },
    "EUR": {
        name: "EUR",
    }
};

export const BillingLanguage = {
    "cs": {
        name: "Czech",
    },
    "en": {
        name: "English",
    }
};

export const BILLING_FREQUENCY_1 = "1";
export const BILLING_FREQUENCY_3 = "3";
export const BILLING_FREQUENCY_6 = "6";
export const BILLING_FREQUENCY_12 = "12";

export const BillingFrequencies = {
    "1": {
        name: "Monthly",
    },
    "3": {
        name: "Quarterly",
    },
    "6": {
        name: "Half-year",
    },
    "12": {
        name: "Annually",
    },

};

export const DEFAULT_PLAN = "trial";
export const PayPlans = {
    "beta": {
        name: "Beta",
        priority: 10,
    },
    "forever-free": {
        name: "Full plan for free for customers",
        priority: 10,
    },
    "developer": {
        name: "Full plan for our developers",
        priority: 50,
    },
    "trial": {
        name: "2-Weeks Trial",
        priority: 10,
    },
    "plan-1": {
        name: "Personal Plan",
        priority: 10,
    },
    "plan-2": {
        name: "Standard Plan",
        priority: 20,
    },
    "plan-3": {
        name: "Premium Plan",
        priority: 30,
    },
    "plan-4": {
        name: "Enterprise Plan",
        priority: 40,
    },
};


export default declareEntity({
    entity: "organisations",
    graphQL: "Organisation",
    name: "Organisations",
    dynamoPrefix: 'org',
    storageType: 'central',
    writePermission: [
        Permission.PERM_EDIT_ORGANISATION
    ],
    createPermission: [
        Permission.PERM_ADD_ORGANISATION
    ],
    defaultTitle: (data) => {
        return data['name'];
    },
    defaultOrder: ['name'],
    fields: (types) => { return {
        id: {
            name: "Organisation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        name: {
            name: "Organisation name",
            type: "string",
            trim: true,
            defaultValue: "",
            filterable: true,
            required: true
        },
        searchName: {
            name: "Search name",
            type: "string",
            trim: true,
            userEditable: false,
            defaultValue: "",
            filterable: true,
        },
        billingName: {
            name: "Billing name",
            type: "string",
            trim: true,
            defaultValue: "",
            filterable: true,
        },
        customerOrderNo: {
            name: "Customer Order No",
            type: "string",
            defaultValue: "",
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        customerInvoiceText: {
            name: "Customer Invoice Text",
            type: "string",
            defaultValue: "",
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        billingCurrency: {
            name: "Billing Currency",
            type: "enum",
            defaultValue: DEFAULT_CURRENCY,
            values: BillingCurrency,
        },
        billingLanguage: {
            name: "Billing Language",
            type: "enum",
            defaultValue: DEFAULT_LOCALE,
            values: BillingLanguage,
        },
        lockedAdding: {
            name: "Adding new integration can be only over API",
            type: "boolean",
            defaultValue: false,
            userEditable: true,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        address: {
            name: "Address",
            type: "string",
            defaultValue: "",
        },
        street: {
            name: "Street",
            type: "string",
            defaultValue: "",
        },
        blocked: {
            name: "It is blocked",
            type: "boolean",
            defaultValue: false,
            userEditable: true,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        blockedReason: {
            name: "Why is it blocked",
            type: "string",
            userEditable: true,
            permission: Permission.PERM_INSTANCE_BILLING,
            visibility: (data) => { return data['blocked']; },
        },
        blockedAt: {
            name: "Blocked At",
            type: "datetime",
            userEditable: true,
            permission: Permission.PERM_INSTANCE_BILLING,
            visibility: (data) => { return data['blocked']; },
        },
        encryptKey: {
            name: "Encrypt Key",
            type: "string",
            userEditable: false,
            import: false,
            export: false,
            hideInApi: true,
            defaultValue: () => {
                return uuidv4().substring(0, 16).replace("-", "");
            },
            visibility: () => { return false; },
        },
        useInkaso: {
            name: "Use inkaso",
            type: "boolean",
            defaultValue: false,
            visibility: (data) => { return !data['billedBy_id']; },
        },
        emailFillBillingInfo: {
            name: "Email for fill Billing Info sent",
            type: "datetime",
            userEditable: false,
        },
        bankAccount: {
            name: "Bank Account",
            type: "string",
            visibility: (data) => { return data['useInkaso'] && !data['billedBy_id']; },
            descriptionHtml: "You have to allow inkaso from our bank account - CZK: 2801103076/2010, EUR: CZ7420100000002901842706. <a href=\"https://www.dativery.com/cs/blogy/inkaso/\">How to setup Inkaso</a>.",
        },
        city: {
            name: "City",
            type: "string",
            defaultValue: "",
        },
        zip: {
            name: "ZIP",
            type: "ZIP",
            defaultValue: "",
        },
        vatId: {
            name: "VAT ID / DIČ / IČ-DPH",
            type: "vatId",
            trim: true,
            defaultValue: "",
        },
        customerNo: {
            name: "Customer Number",
            type: "string",
            trim: true,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        identNum: {
            name: "Identification number",
            type: "string",
            trim: true,
            defaultValue: "",
        },
        phoneNumber: {
            name: "Phone Number",
            type: "phoneNumber",
            trim: true,
            defaultValue: "",
        },
        email: {
            name: "E-mail",
            type: "email",
            trim: true,
            defaultValue: "",
            descriptionHtml: "You can add more e-mails separated by comma."
        },
        billingEmail: {
            name: "Billing E-mail",
            type: "email",
            trim: true,
            defaultValue: "",
        },
        www: {
            name: "WWW",
            type: "URL",
            trim: true,
            defaultValue: "",
        },
        logo: {
            name: "Logo (URL)",
            type: "IMG",
            trim: true,
        },
        labels: {
            name: "Labels",
            type: "string",
            defaultValue: "",
        },
        country: {
            name: "Country",
            type: "country",
            defaultValue: "CZ",
            values: countries
        },
        timezone: {
            name: "Time Zone",
            type: "string",
            defaultValue: DEFAULT_TIMEZONE,
        },
        cluster: {
            name: "Cluster",
            type: "string",
            hideInApi: true,
            userEditable: false,
            export: false,
            import: false,
            permission: Permission.PERM_INSTANCE_ADMIN,
        },
        payPlan: {
            name: "PayPlan",
            type: "enum",
            defaultValue: DEFAULT_PLAN,
            values: PayPlans,
            userEditable: false,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        description: {
            name: "Description",
            type: "text",
            defaultValue: ""
        },
        implementationDetails: {
            name: "Implementation Details",
            type: "text",
            defaultValue: "",
            permission: Permission.PERM_INSTANCE_SUPPORT,
        },
        implementationDetailsLink: {
            name: "Implementation Detail Link",
            type: "url",
            defaultValue: "",
            permission: Permission.PERM_INSTANCE_SUPPORT,
        },
        technicalWatchers: {
            name: "Technical Watchers",
            type: "object",
            defaultValue: {},
            hideInApi: true,
        },
        adminExtraEmail: {
            name: "Admin extra emails",
            type: "text",
            trim: true,
            defaultValue: "",
        },
        enabled: {
            name: "Enabled",
            type: "boolean",
            defaultValue: true
        },
        maintanance: {
            name: "Maintanance",
            type: "boolean",
            defaultValue: false,
        },
        deleted: {
            name: "Deleted",
            type: "boolean",
            defaultValue: false,
            filterable: true,
        },
        deletedAt: {
            name: "Deleted At",
            type: "datetime",
            userEditable: false,
        },
        requiresBrowserExtension: {
            name: "Requires Browser Extension",
            type: "boolean",
            defaultValue: false,
            hideInApi: true,
        },
        featureFlags: {
            name: "Feature Flags",
            type: "object",
            defaultValue: [],
            userEditable: false,
            hideInApi: true,
        },
        billedBy: {
            name: "Bill together with",
            type: "relation",
            to: () => types['organisations'],
            userEditable: true,
            description: "Bill this organisation as part of another organisation."
        },
        variableSymbol: {
            name: "Variable symbol",
            type: "string",
            trim: true,
            defaultValue: "",
            permission: Permission.PERM_INSTANCE_ADMIN,
        },
        consultant: {
            name: "Consultant",
            type: "relation",
            filterable: true,
            to: () => types['users'],
            permission: Permission.PERM_INSTANCE_ADMIN,
        },
        billingStatus: {
            name: "Billing status",
            type: "enum",
            userEditable: false,
            filterable: true,
            defaultValue: "",
            values: BillingStatus,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        billingValidTo: {
            name: "Billing status",
            type: "datetime",
            filterable: true,
            userEditable: false,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        billingFrequency: {
            name: "Billing frequency",
            type: "enum",
            defaultValue: BILLING_FREQUENCY_1,
            values: BillingFrequencies,
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        versionStrategy: {
            name: "Version Strategy",
            type: "enum",
            defaultValue: VERSION_STRATEGY_NORMAL,
            values: VersionStrategyForOrganisation,
            permission: Permission.PERM_INSTANCE_ADMIN,
        },
        reviewInvoice: {
            name: "Review Invoice",
            type: "boolean",
            permission: Permission.PERM_INSTANCE_BILLING,
        },
        cronSpread: {
            name: "Cron spread",
            type: "number",
            userEditable: false,
            permission: Permission.PERM_INSTANCE_ADMIN,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        database: {
            name: "Database",
            type: "relation",
            to: () => types['databases'],
            userEditable: false,
            permission: Permission.PERM_INSTANCE_ADMIN,
        },
        statistics: {
            name: "Organisation Statistics",
            type: "relation",
            to: () => types['organisationStatistics'],
            userEditable: false,
            export: false,
            import: false,
            hideInApi: true,
            controllerFn: "getStatistics",
        },
        companySearchAddon: {
            name: "Company Search Addon",
            type: "relation",
            to: () => types['organisationAddons'],
            userEditable: false,
            export: false,
            import: false,
            hideInApi: true,
            controllerFn: "getCompanySearchAddon",
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        author: {
            name: "Created By",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        channelErrorTypes: {
            name: "Channel Error Types",
            type: "object",
            hideInApi: true,
            defaultValue: [],
            args: {
                author_id: {
                    type: "string"
                },
                displayNameLike: {
                    type: "string"
                },
                resolvableBy: {
                    type: "string"
                },
                type: {
                    type: "string"
                },
                hasError: {
                    type: "boolean"
                },
                flowId: {
                    type: "string"
                },
                lastErrorTransferAtAfter: {
                    type: "datetime"
                },
                lastErrorTransferAtBefore: {
                    type: "datetime"
                },
            },
            controllerFn: 'getChannelErrorsGroupBy',
        },
    }; },
    relations: (types) => { return {
        organisations2user: {
            type: 'manyToOne',
            to: types['organisation2user'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        users: {
            type: 'manyToOne',
            to: types['users'],
            controllerFn: 'getOrganisationUsers',
        },
        adminUsers: {
            type: 'manyToOne',
            to: types['users'],
            controllerFn: 'getOrganisationAdminUsers',
        },
        invitations: {
            type: 'manyToOne',
            to: types['invitations'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ],
            args: {
                email: {
                    type: 'string',
                }
            },
        },
        events: {
            type: 'manyToOne',
            to: types['organisationEvents'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ],
        },
        billedByOrgs: {
            type: 'manyToOne',
            to: types['organisations'],
            controllerFn: 'getBilledByOrganisations',
        },
        runningJobs: {
            type: 'oneToMany',
            to: types['runningJobs'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id",
                    asFilterOnly: true,
                }
            ]
        },
        channels: {
            type: 'oneToMany',
            to: types['channels'],
            exposeInApi: true,
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        fetches: {
            type: 'oneToMany',
            to: types['fetches'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        flowInvocations: {
            type: 'oneToMany',
            to: types['flowInvocations'],
            export: false,
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        eventDetectors: {
            type: 'oneToMany',
            to: types['eventDetectors'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        flows: {
            type: 'oneToMany',
            to: types['flows'],
            exposeInApi: true,
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        organisationAddons: {
            type: 'oneToMany',
            to: types['organisationAddons'],
            export: true,
            defaultValue: () => {
                return {};
            },
        },
        unactivatedChannels: {
            type: 'oneToMany',
            description: "Returns unactivated channels (activated=false)",
            to: types['channels'],
            controllerFn: 'getUnactivatedChannels',
            args: {
                channelDefUrlFragment: {
                    type: 'string',
                },
                channelDefId: {
                    type: 'string',
                }
            },
        },
        storeInfos: {
            type: 'oneToMany',
            to: types['storeInfos'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        usedScenarios: {
            type: 'oneToMany',
            to: types['usedScenarios'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        usedScenariosByURL: {
            type: 'oneToMany',
            description: "Filters 'usedsCenarios' according to URL Fragment.",
            to: types['usedScenarios'],
            args: {
                urlFragment: {
                    type: 'string',
                }
            },
            controllerFn: 'getUsedScenariosByURLFragment',
        },
        relevantScenarios: {
            type: 'oneToMany',
            to: types['scenarios'],
            args: {
                onlyActiveChannels: {
                    type: 'boolean',
                },
                first: {
                    type: 'int'
                },
                requiredPayPlan: {
                    type: 'string'
                },
                nameLike: {
                    type: 'string'
                }
            },
            controllerFn: 'getRelevantScenarios',
        },
        allUsedChildrenOfEntityDef: {
            type: 'oneToMany',
            to: types['channelEntityDefs'],
            description: "Returns all channelEntityDefs that are inherited from 'entityDef_id'",
            args: {
                entityDef_id: {
                    type: 'ID'
                },
            },
            controllerFn: 'getAllUsedChildrenOfEntityDef',
        },
        allUsedChildrenRelationOfEntityDef: {
            type: 'oneToMany',
            to: types['entityDefs'],
            description: "Returns all entityDefs that are in relation to entityDef inherited from 'entityDef_id'",
            args: {
                entityDef_id: {
                    type: 'ID'
                },
            },
            controllerFn: 'getAllUsedChildrenRelationOfEntityDef',
        },
        relationDefs: {
            type: 'oneToMany',
            to: types['relationDefs'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        screens: {
            type: 'oneToMany',
            to: types['screens'],
            IndexName: 'organisation_id-channel_id-index',
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        hooks: {
            type: 'oneToMany',
            to: types['hooks'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        jobs: {
            type: 'oneToMany',
            to: types['jobs'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        billingItems: {
            type: 'oneToMany',
            to: types['billingItems'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ]
        },
        billingRules: {
            type: 'manyToOne',
            to: types['billingRules'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                }
            ],
        },
		companySearchSystemChannels: {
            type: 'oneToMany',
            to: types['channelDefs'],
            userEditable: false,
            export: false,
            import: false,
            controllerFn: 'getCompanySearchSystemChannels',
        },
		relatedOrganisations: {
            type: 'oneToMany',
            to: types['organisations'],
            userEditable: false,
            export: false,
            import: false,
            controllerFn: 'getRelatedOrganisations',
        },
		relatedUsers: {
            type: 'oneToMany',
            to: types['users'],
            userEditable: false,
            export: false,
            import: false,
            controllerFn: 'getRelatedUsers',
        },
		companySearchOrgChannels: {
            type: 'oneToMany',
            to: types['channels'],
            args: {
				// timestamp to allow always refreshed data
                timestamp: {
                    type: 'string',
                }
			},
            userEditable: false,
            export: false,
            import: false,
            controllerFn: 'getCompanySearchOrgChannels',
        },
        logger: {
            type: 'oneToMany',
            to: types['loggers'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                },
                {
                    from: "instance_id",
                    to: "instance_id"
                },
            ]
        },
        channelErrors: {
            type: 'oneToMany',
            to: types['channelErrors'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                },
                {
                    from: "instance_id",
                    to: "instance_id"
                },
            ]
        },
        notifications: {
            type: 'oneToMany',
            to: types['organisationNotifications'],
            foreignKeys: [
                {
                    from: "id",
                    to: "organisation_id"
                },
                {
                    from: "instance_id",
                    to: "instance_id"
                },
            ]
        },

    }; }
});
